import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IContactModel } from '@apps-common/types/portal/contact'

export const updateContact = async (model: IContactModel): Promise<IContactModel> =>
  axios.post(`/me/UpdateMyDetails`, model).then((res) => res.data?.data)

type Props = {
  model: IContactModel
}

export const useUpdateContact = (notify?: boolean, onSuccess?: (data: IContactModel) => void) =>
  useMutation({
    mutationKey: ['updateContact'],
    mutationFn: ({ model }: Props) => updateContact(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated details.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update details.')
      }
    },
    throwOnError: false
  })
